import { isEmpty } from "lodash";
import {
  ButtonGhostV2,
  ButtonPrimaryV2,
  SANS_2,
  TagSelectV2,
  colors,
  icons,
} from "oolib";
import React, { useEffect, useRef, useState } from "react";

import {
  useCreateTagV3,
  useMultipleGetTagsV3,
} from "../../../../../../../../utils/react-query-hooks/tags";

import {
  convertSingleValueToTagsValue,
  convertTagDocsDataToOptions,
} from "../../../../../../DynamicTagsInputs/utils";

import {  __GetContentTypeConfigNew } from "../../../../../../../../utils/getters/gettersV2";

import { BadgeNumber } from "../../../../../../../generalUI/BadgeNumber";
import { TagsSubmenu } from "./comps/TagsSubmenu";
import {
  ActionButtonsContainerStyled,
  Divider,
  MenuContainerStyled,
  MenuItemStyled,
  OtherOptionsContainerStyled,
  TagSelectWrapperStyled,
} from "./styled";
import { toggleTagTypesLookup } from "../configs/toggleTagTypesLookup";

const { greyColor15, annoPink, annoBlue } = colors;
const { CaretRight } = icons;

const bgColor = {
  quotes: annoPink, // lightPink
  vocabs: annoBlue 
};

//------------------------------------------------------------- PARENT COMP ----------------------------------------------------

export const AnnoLightboxInput = ({
  // id,
  onChange,
  value,
  tagTypesConfig,
  toggleTagTypesConfig = [], // shape: [ { tagType: 'quotes' }, ... ]
  handleOnConfirm,
  handleOnCancel,
}) => {

  const toggleTagTypes = toggleTagTypesConfig.map(d => {
    const thisTagType = d.tagType;
    return toggleTagTypesLookup.find(dd => dd.tagType === thisTagType)
  }).filter(Boolean)

  const containerRef = useRef(null);

  const [showTagsLightbox, setShowTagsLightbox] = useState({});

  //---------------------------------------QUERY HOOKS----------------------------------------------------------
  

  const MainMenuRef = useRef();


  const handleShowTagsLightbox = (e, thisTagTypeConfig) => {
    e.preventDefault();
    setShowTagsLightbox({
      top: e.currentTarget.offsetTop,
      height: e.currentTarget.offsetHeight,
      ...thisTagTypeConfig, //tagType && //allowCreateTag
    });
  };

  const genToggleTags = () => {
    if (!toggleTagTypes?.length === 0) return null;

    return (
      <div
        style={{
          display: "flex",
          alignContent: "center",
          gap: "1rem",
          border: "none",
        }}
      >
        {toggleTagTypes.map((d) => {
          let option = { ...d, value: d._id };
          let isSelected = value[option.tagType]?.data?.length > 0;

          return (
            <TagSelectWrapperStyled
              onMouseDown={(e) => {
                // preventDefault on mousedown keeps the Lexical editor's
                // selection while clicking a tag. v2 TagSelect doesn't forward
                // onMouseDown, so it lives on the wrapper (mousedown bubbles up).
                e.preventDefault();
                onChange(
                  option.tagType,
                  isSelected
                    ? undefined
                    : convertSingleValueToTagsValue(option.tagType, option)
                );
              }}
            >
              <TagSelectV2
                display={option.singular}
                isSelected={isSelected}
                style={
                  isSelected
                    ? {
                        color: "black",
                        backgroundColor: bgColor[option.tagType],
                        border: `2px solid ${bgColor[option.tagType]}`,
                        ':hover': {
                          backgroundColor: 'red',
                          color: 'white',
                          cursor: 'pointer',
                        },
                      }
                    : { border: `2px solid ${greyColor15}`,  color: 'black' }
                }
              ></TagSelectV2>
            </TagSelectWrapperStyled>
          );
        })}
      </div>
    );
  };

  return (
   
    <div ref={containerRef} onMouseDown={(ev) => ev.preventDefault()}>
      <MenuContainerStyled ref={MainMenuRef}>
        {tagTypesConfig.map((d) => {
          const title =
          __GetContentTypeConfigNew(d.tagType)?.general?.content?.title || d.tagType;          
          const active = showTagsLightbox.tagType === d.tagType;
          const selectCount = value[d.tagType] && value[d.tagType].data.length;

          return (
            <MenuItemStyled
              key={d.tagType}
              onMouseDown={(e) => handleShowTagsLightbox(e, d)}
              active={active}
            >
              <div style={{ display: "flex", gap: "1rem" }}>
                <SANS_2 semibold={active}>{title}</SANS_2>{" "}
                {selectCount ? <BadgeNumber number={selectCount} /> : null}
              </div>
              <CaretRight weight={active ? "bold" : "regular"} size={12} />
            </MenuItemStyled>
          );
        })}

        <OtherOptionsContainerStyled>
          <Divider />
          {genToggleTags()}
          <Divider />
          <ActionButtonsContainerStyled>
            <ButtonGhostV2 onClick={(e) => handleOnCancel(e)}>Cancel</ButtonGhostV2>
            <ButtonPrimaryV2 disabled={isEmpty(value)} onClick={handleOnConfirm}>
              Apply
            </ButtonPrimaryV2>
          </ActionButtonsContainerStyled>
        </OtherOptionsContainerStyled>
      </MenuContainerStyled>

      {showTagsLightbox.tagType && (
        <TagsSubmenu
          value={value}
          onChange={onChange}
          containerRef={containerRef}
          showTagsLightbox={showTagsLightbox}
        />
      )}
    </div>
  );
};


